export default __webpack_public_path__ + "static/cloud-computing-logo-aaced650d7bdc1a641d410e5d847b6c0.png";